export default __webpack_public_path__ + "static/media/img-44-cadmus.622355de.jpg";